import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import {PazienteService} from "./paziente_service";
import {HttpResponse} from "@angular/common/http";
import {AuthService} from "./auth_service";
import { PrimeNGConfig } from 'primeng/api';
import {buildDayTableRenderRange} from "@fullcalendar/daygrid/internal";

@Injectable({
    providedIn: 'root'
})
export class LanguageService {
    private languageChanged = new BehaviorSubject<string>('it'); // Lingua predefinita
    languageChanged$ = this.languageChanged.asObservable();

    private localeSettings = new BehaviorSubject<any>({});
    localeSettings$ = this.localeSettings.asObservable();

    constructor(
        private translate: TranslateService,
        private pazienteService: PazienteService,
        private authService: AuthService,
        private primengConfig: PrimeNGConfig
    ) {
        let browser_lang = navigator.language;
        if (browser_lang == 'it' || browser_lang == 'it-IT') {
           browser_lang = 'it';
        } else {
           browser_lang = 'en';
        }
        const lang = localStorage.getItem('lang') || browser_lang;
        this.translate.setDefaultLang(lang);
        this.translate.use(lang);
        this.loadCalendarLocale();
    }

    changeLanguage(lang: string): void {
        this.translate.use(lang).subscribe(() => {
            localStorage.setItem('lang', lang);
            this.languageChanged.next(lang); // Notifica il cambio di lingua
            this.loadCalendarLocale();
            this.authService.getUserData('soft').subscribe({
                next: (response: HttpResponse<any>) => {
                    this.pazienteService.updateLingua(response.body.id, lang).subscribe({
                        next: (response: HttpResponse<any>) => {},
                        error: (error) => {}
                    })
                },
                error: (error) => {}
            });
            ;
        });
    }

    private loadCalendarLocale(): void {
        this.translate.get('calendar').subscribe((res: any) => {
            this.localeSettings.next(res);
            this.primengConfig.setTranslation(res); // ✅ Imposta la traduzione in PrimeNG
        });
    }
}
